import script from "./PatientSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientSummary.vue?vue&type=script&setup=true&lang=js"

import "./PatientSummary.vue?vue&type=style&index=0&id=62c305cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c305cc"]])

export default __exports__